import { Component, OnInit, Input, OnChanges, HostListener, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-environment-card',
  templateUrl: './device-environment-card.component.html',
  styleUrls: ['./device-environment-card.component.scss']
})
export class DeviceEnvironmentCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() deviceInfo;
  deviceImage: string;
  auxSelectedCenter: CenterLite;
  centerInternalId: string;
  centerList: CenterLite[];
  editingLocked: boolean;
  updateDeviceSubscription: Subscription;
  environmentForm = new FormGroup({
    deviceName: new FormControl({ value: '', disabled: true }),
    deviceSelectedCenter: new FormControl({ value: null, disabled: true }, Validators.required),
    deviceDescription: new FormControl({ value: '', disabled: true }),
    deviceLocation: new FormControl({ value: '', disabled: true }),
    deviceNote: new FormControl({ value: '', disabled: true })
  });

  constructor(private userStorageService: UserStorageService,
    private devicesService: DevicesDevicesService,
    private snackBarService: SnackBarService,
    private eRef: ElementRef) { }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.editingLocked = true;
  }

  ngOnChanges() {
    if (this.deviceInfo) {
      this.resetForm();
      this.lockEdition();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {

    } else {
      if (event.target.className !== 'mat-option-text') {
        if (this.deviceInfo && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
          this.editingLocked = true;
        }
      }
    }
  }

  public submitForm() {
      this.updateDeviceSubscription = this.devicesService.updateDevice(this.deviceInfo.InternalId, this.environmentForm.get('deviceName').value, this.environmentForm.get('deviceDescription').value, this.environmentForm.get('deviceNote').value, this.environmentForm.get('deviceLocation').value, this.environmentForm.get('deviceSelectedCenter').value.InternalId).pipe(
        tap(o => this.snackBarService.open('devices-page.snackbar messages.update device success', 'success')),
        tap(o => this.lockEdition()),
        tap(o => this.devicesService.refreshDevice()),
        catchError(error => { this.snackBarService.open(error['error']['message'], 'error'); return EMPTY; })
      ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackBarService.open(validation, 'error');
      }
    }
  }

  private validateForm() {
    return true;
  }

  public resetForm() {
    this.environmentForm.patchValue({
      deviceName: this.deviceInfo.DeviceName,
      deviceSelectedCenter: this.setSelectedCenter(),
      deviceDescription: this.deviceInfo.Description,
      deviceLocation: this.deviceInfo.Location,
      deviceNote: this.deviceInfo.Note
    });
  }

  private unlockEdition() {
    this.environmentForm.get('deviceName').enable();
    this.environmentForm.get('deviceSelectedCenter').enable();
    this.environmentForm.get('deviceDescription').enable();
    this.environmentForm.get('deviceLocation').enable();
    this.environmentForm.get('deviceNote').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.environmentForm.get('deviceName').disable();
    this.environmentForm.get('deviceSelectedCenter').disable();
    this.environmentForm.get('deviceDescription').disable();
    this.environmentForm.get('deviceLocation').disable();
    this.environmentForm.get('deviceNote').disable();
    this.editingLocked = true;
  }

  public setSelectedCenter() {
    if (this.deviceInfo && this.centerList  && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.deviceInfo.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  ngOnDestroy() {
    if (this.updateDeviceSubscription) { this.updateDeviceSubscription.unsubscribe(); }
  }

}
